import * as types from './types'
import { IProductWarrantyClaim, IResponse, IUUIDResponse } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const getProductWarrantyClaimDetails = (uuid: string) =>
  AsyncAction<IResponse<IProductWarrantyClaim>>({
    type: [types.GET_PRODUCT_WARRANTY_CLAIMS, types.GET_PRODUCT_WARRANTY_CLAIMS_SUCCESS, types.GET_PRODUCT_WARRANTY_CLAIMS_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: `/modules/support-product-warranty-claims/${uuid}`
      }
    }
  })

export const updateProductWarrantyClaim = (productWarrantyClaim: Partial<IProductWarrantyClaim>) =>
  AsyncAction<IUUIDResponse>({
    type: [types.UPDATE_PRODUCT_WARRANTY_CLAIMS, types.UPDATE_PRODUCT_WARRANTY_CLAIMS_SUCCESS, types.UPDATE_PRODUCT_WARRANTY_CLAIMS_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'PUT',
        url: `/modules/support-product-warranty-claims/${productWarrantyClaim.UUID}`,
        data: productWarrantyClaim
      }
    }
  })
